import { __assign, __extends } from "tslib";
import React from 'react';
import { st, classes } from './HeaderNavStepper.st.css';
import { NavStepper } from '../NavStepper';
var HeaderNavStepper = /** @class */ (function (_super) {
    __extends(HeaderNavStepper, _super);
    function HeaderNavStepper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNavStepper.prototype.render = function () {
        return (React.createElement(NavStepper, __assign({}, this.props, { className: st(classes.root, { fontUpgrade: this.props.fontUpgrade }, this.props.className) }), this.props.children));
    };
    HeaderNavStepper.Step = NavStepper.Step;
    HeaderNavStepper.propTypes = NavStepper.propTypes;
    return HeaderNavStepper;
}(React.PureComponent));
export { HeaderNavStepper };
//# sourceMappingURL=HeaderNavStepper.js.map